import { api } from "boot/axios";
import { firestore } from "boot/firebase";
import state from "src/modules/auth/store/auth/state";

export async function getMentorChatRooms ({commit}) {
  try {
    const resp = await api.get('/mentor/chat/')
    commit('setChatrooms',resp.data)
  } catch (error) {
    console.log(error)
    return []
  }
}

export async function firstChatroomLoad({commit, state}, mentorID) {
    firestore
      .collection('mentor_student_chatrooms')
      .where('mentor_id', '==', mentorID)
      .where('last_message_at', '!=', null)
      .orderBy('last_message_at', 'desc')
      .get((querySnapshot) => {
        commit('setFirebaseChatrooms', querySnapshot.docs)
      })
}

export function chatroomSnapshot({commit}, mentorID){
    if(state.chatroomsSnapshot == null) {
      //console.log(mentorID)
      let snapshot = firestore
        .collection('mentor_student_chatrooms')
        .where('mentor_id', '==', mentorID)
        .where('last_message_at', '!=', null)
        .orderBy('last_message_at', 'desc')
        .onSnapshot((querySnapshot) => {
          //console.log("chatroomSnapshot")
          //console.log(querySnapshot.docs)
          commit('setFirebaseChatrooms', querySnapshot.docs)
        })
      commit('setChatroomsSnapshot',snapshot)
    }
    
}